import ContentfulToApiStory from 'models/data/mappings/ContentfulToApiStory'
import { getStoryBySlug as getContentfulStoryBySlug } from 'services/server/contentful/ContentfulStory'
import { getStoryById as getContentfulStoryById } from "services/server/contentful/ContentfulStory";

export async function getStoryBySlug(storySlug: string) {
  const contentfulStory = await getContentfulStoryBySlug(storySlug);
  const apiStory = await ContentfulToApiStory.map(contentfulStory);
  return apiStory;
}

export async function getStoryById(storyId: string) {
  const contentfulStory = await getContentfulStoryById(storyId);
  const apiStory = await ContentfulToApiStory.map(contentfulStory)
  return apiStory
}